import { HStack, Link } from '@montel/montelpro-shared-components-v2';
import { LabelAndValue } from 'components/common/LabelAndValue/LabelAndValue';
import { MontelAccount } from 'domain/account/interfaces';

export const UserDetails: React.FC<{
	account: MontelAccount;
}> = ({ account }) => (
	<HStack fullWidth align="center" justify="space-between">
		<LabelAndValue
			label="Name"
			value={`${account.firstName} ${account.lastName}`}
			textSize="sm"
			labelSize="xxs"
		/>
		<LabelAndValue
			label="Email"
			value={account.email.value}
			textSize="sm"
			labelSize="xxs"
		/>
		<LabelAndValue
			label="Company"
			value={
				account.company.id ? (
					<Link href={`/companies/${account.company.id}`}>
						{account.company.name}
					</Link>
				) : (
					account.company.name
				)
			}
			textSize="sm"
			labelSize="xxs"
		/>
	</HStack>
);
